<template>
  <!-- Special -->
  <div style="position: relative">
    <h3 style="margin: 15px; text-align: center">
      Special Close/Open
      <v-btn
        icon
        absolute
        @click="specialDialog = true"
        v-if="!isEditStoreList"
        style="top: -5px; right: 15px"
      >
        <v-icon color="black">edit</v-icon>
      </v-btn>
    </h3>
    <hr style="margin-bottom: 15px" />
    <editStoreSpecial
      :dialog="specialDialog"
      @setDialog="specialDialog = $event"
    />
    <v-data-table
      :headers="headers"
      :items="store_detail.store_close"
      hide-actions
      class="head-time"
      style="max-height: 500px; overflow: auto"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center" style="padding: 15px">
          {{ props.item.store_close_date }}
        </td>
        <td class="text-xs-center" style="padding: 15px">
          {{ props.item.store_close_msg }}
        </td>
        <td class="text-xs-left" style="padding-right: 0">
          {{ props.item.store_close_note }}
        </td>
      </template>
      <template slot="no-data">
        <center>
          <h3>ไม่มีวันหยุดพิเศษ</h3>
        </center>
      </template>
    </v-data-table>
  </div>
  <!-- End-Special -->
</template>

<script>
import editStoreSpecial from "../EditStore/EditStoreSpecial";
import { mapGetters } from "vuex";
export default {
  props: ["store_detail"],
  components: {
    editStoreSpecial,
  },
  data() {
    return {
      specialDialog: false,
      headers: [
        {
          text: "Date",
          align: "center",
          value: "store_close_date",
          sortable: false,
        },
        {
          text: "Type",
          align: "center",
          value: "store_close_msg",
          sortable: false,
        },
        {
          text: "Note",
          align: "center",
          value: "store_close_note",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["isEditStoreList"]),
  },
  methods: {},
};
</script>

<style>
</style>
